export default __webpack_public_path__ + "static/bariol_serif_regular_italic-webfont-96002f8b9d7d7e11ab64ce1be2acc7f6.eot";